import { DateTime } from '@ksyos/date-time';
import type { ProcessActivityBadge } from '@common/interfaces';
import type { CaroProcessActivity } from '@common/interfaces/caroProcessActivity';
import { CustomControlCode } from '@common/enums';

export function getBadge(count: number): ProcessActivityBadge {
    if (count <= 0) {
        throw new Error('Expected count to be > 0');
    }
    if (count === 1) {
        return { color: 'neutral', text: 'Voor het eerst bellen' };
    } else if (count === 2) {
        return { color: 'orange', text: 'Voor de 2e keer bellen' };
    }

    return { color: 'red', text: `Voor de ${count}e keer bellen` };
}

export function getPreviousBariPreCaroInactivityPoliReportActivities(
    processActivities: CaroProcessActivity[],
    untilDateTime: DateTime
): CaroProcessActivity[] {
    return processActivities.filter(
        (activity) =>
            activity.serviceActivity.customControlCode === CustomControlCode.BariPreCaroInactivityPoliReport &&
            DateTime.from(activity.performedDatetime).isBefore(untilDateTime)
    );
}
